/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');

var CorpFinExemIssuerFormView = require('./CorpFinExemIssuerFormView');
var CorpFinOfferingFormView = require('../../common/views/CorpFinOfferingFormView');

var SubmitRecord = require('../../common/services/SubmitRecord');

var tmplCorpFinExemptionNewView = require('../templates/CorpFinExemptionNewView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinExemptionNewView,

  className: 'corp-fin-exemption-new-view container-fluid',

  ui: {
    issuerForm: '.issuer-form-container',
    offeringForm: '.offering-form-container',
    breadcrumb: '.breadcrumb-container',
    submit: '.submit'
  },

  regions: {
    issuerForm: '@ui.issuerForm',
    offeringForm: '@ui.offeringForm',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  childEvents: {
    'fileType:changed': 'onChangeFileType'
  },

  onBeforeShow: function() {
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#corpfin/dashboard',
            text: 'Home'
          },
          {
            text: 'New Exemption'
          }
        ]
      })
    );

    this.issuerForm = new CorpFinExemIssuerFormView({
      model: this.model,
      isNewExemption: true
    });

    this.offeringForm = new CorpFinOfferingFormView({
      model: this.model,
      isExemption: true
    });

    

    this.showChildView('issuerForm', this.issuerForm);
    this.showChildView('offeringForm', this.offeringForm);
    
  },

  onChangeFileType: function(childView, fileTypeId) {
    this.offeringForm.onChangeFileType(fileTypeId);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        SubmitRecord(formData)
          .done(function(newRecordId) {
            Radio.channel('navigate').trigger('show:int:cf:exemption-dashboard', newRecordId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    var validationArray = [
      this.ui.issuerForm.parsley().whenValidate(),
      this.ui.offeringForm.parsley().whenValidate()      
    ];

    return $.when.apply($, validationArray);
  },

  getFormData: function() {
    var record = this.model.get('record') || {};

    var recordDetails = {
      reecordId: this.model.get('recordId'),
      currentRecordName: record.recordName,
      recordCategoryId: '2' //exemption
    };

    var formData = _.extend(
      recordDetails,
      this.issuerForm.getFormData(),
      this.offeringForm.getFormData()
     
    );

    return formData;
  }
});
